import { useLocation } from "react-router";
import { Link } from "react-router-dom";
import classNames from "classnames";
import styles from "./index.module.scss";

type PropsType = {
  links: Array<{
    url: string;
    text: string;
    notifications?: number;
  }>;
  disabled?: boolean;
};

const TabNavigation = ({ links, disabled }: PropsType) => {
  const location = useLocation();

  //create compact values with K, M, B, T for admin user tab navigation
  const abbreviateNotificationValues = (notification: number) => {
    let unit = "";
    let divider = 1;
    if (notification >= 1e3) {
      if (notification < 1e6) {
        divider = 1e3;
        unit = "K";
      } else if (notification < 1e9) {
        divider = 1e6;
        unit = "M";
      } else if (notification < 1e12) {
        divider = 1e9;
        unit = "B";
      } else {
        divider = 1e12;
        unit = "T";
      }
    }
    const baseValue = notification / divider;
    const newValue = baseValue
      .toFixed(baseValue > 10 ? 0 : 1)
      .replace(/\.0$/, "");
    return `${newValue}${unit}`;
  };

  return (
    <div className={styles.content}>
      <nav className={styles.nav}>
        {links.map((i) => (
          <Link
            key={i.text}
            to={i.url}
            className={classNames(styles.navItem, {
              [styles.navItemActive]:
                `${location.pathname}${location.hash}` === i.url,
                [styles.navItemDisabled]: disabled,
            })}
          >
            {i.text}
            {i.notifications ? (
              <span
                className={classNames(styles.navCircle, {
                    [styles.navCircleDisabled]: disabled,
                })}>
                {abbreviateNotificationValues(i.notifications)}
              </span>
            ) : null}
          </Link>
        ))}
      </nav>
    </div>
  );
};
export default TabNavigation;
